// extracted by mini-css-extract-plugin
export default {"zoomWrapper":"ProductImageZoom_zoomWrapper__HlAnu"};